export default __webpack_public_path__ + "static/media/img--interiors-3.11c37210.jpg";